import { gql } from '@apollo/client';
export const StatFeatureCareSummary = gql `
    fragment StatFeatureCareSummary on CareSummaryFeatureSettings {
        isEnabled
    }
`;
